"use client";

import { useState } from "react";
import Image from "next/image";

/** A collage plate's image that steps aside when its host is down, leaving the
 *  plate's own ground — legacy profile and artwork images live on hosts that
 *  no longer answer, and a broken-image icon in the hero is the first thing
 *  anyone sees. */
export default function PlateImage({ src, sizes, priority = false }: { src: string | null; sizes: string; priority?: boolean }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) return null;
  return (
    <Image
      src={src}
      alt=""
      fill
      preload={priority} fetchPriority={priority ? "high" : undefined}
      loading={priority ? "eager" : "lazy"}
      sizes={sizes}
      style={{ objectFit: "cover" }}
      onError={() => setFailed(true)}
    />
  );
}
